<h1 mat-dialog-title>
    <span class="left">
        <span>{{ (data.lieuParam.isShowAdresseFiltre ? 'lieu.titleAdresse' : 'lieu.title') | translate }}</span>
    </span>
    <span [mat-dialog-close]><i class="zmdi zmdi-close"></i></span>
</h1>
<div mat-dialog-content>
    <mat-tab-group #matTabGroup dynamicHeight animationDuration="0ms" [(selectedIndex)]="tabIndex">
        <mat-tab *ngIf="data.lieuParam.isShowLieuxRecents" label="{{ 'lieu.tabs.lieuxRecents' | translate }}">
            <lieux-recents
                    [lieuParam]="data.lieuParam"
                    (onAdresseSelect)="selectAdresse($event);"
            ></lieux-recents>
        </mat-tab>
        <mat-tab label="{{ data.lieuParam.titleAdresseTab | translate }}">
            <please-wait *ngIf="!listeAdresse && data.lieuParam.isShowAdresseBaseAndEtablissement"></please-wait>
            <adresse-list *ngIf="listeAdresse || data.lieuParam.isShowAdresseFiltre"
                          [listeAdresse]="listeAdresse"
                          [lieuParam]="data.lieuParam"
                          (onAdresseSelect)="selectAdresse($event);"
            ></adresse-list>
        </mat-tab>
        <mat-tab *ngIf="data.lieuParam.isShowAdresseBaseAndEtablissement && listeEtablissement?.length !== 0" label="{{ 'lieu.tabs.etablissements' | translate }}">
            <please-wait *ngIf="!listeEtablissement"></please-wait>
            <etablissement-list [listeEtablissement]="listeEtablissement" (onEtablissementSelected)="selectEtablissement($event);"></etablissement-list>
        </mat-tab>
        <mat-tab #tabSaisie="matTab" *ngIf="isSaisieAutorisee" label="{{ 'lieu.tabs.saisieAdresse' | translate }}">
            <localisation
                    [lieuParam]="data.lieuParam"
                    [geolocalisationTool]="geolocalisationTool"
                    [localisation]="localisationSaisie"
                    [typeAdresse]="typeAdresse"
                    (onLocalisationSelected)="selectAutre($event);"
            ></localisation>
        </mat-tab>
    </mat-tab-group>
</div>
